<template>
  <div class="limits-card">
    <div class="limits-card-header">
      <div class="limits-card-text">
        <bg-text
          type="body-sm"
          weight="bold"
        >
          {{ formattedText.title }}
        </bg-text>
        <bg-icon
          v-tooltip="formattedText.tooltipDescription"
          name="info-outline"
          color="blue-semi-dark"
          class="limits-card-icons"
          size="sm"
        />
      </div>

      <bg-menu>
        <template #button="{ ...attrs}">
          <bg-button
            id="limits-card-menu-button"
            size="sm"
            class="limits-card-menu-button"
            variant="ghost"
            aria-label="Em breve, você poderá editar seus limites por aqui!"
            disabled
          >
            <bg-icon
              size="sm"
              name="more-actions"
              color="grey-semi-dark"
              v-bind="attrs"
            />
          </bg-button>
        </template>
        <bg-menu-item>
          Editar limite
        </bg-menu-item>
      </bg-menu>
    </div>
    <div class="limits-card-divider" />
    <div class="limits-card-text">
      <bg-text type="body-sm">
        Limite definido
      </bg-text>
      <bg-icon
        v-tooltip="`Limite total definido pela Transfeera para suas transações`"
        name="info-outline"
        color="blue-semi-dark"
        class="limits-card-icons"
        size="sm"
      />
    </div>

    <bg-text
      type="body-md"
      color="grey-dark"
      weight="bold"
    >
      {{ $format.currency(limit.value) }}
    </bg-text>
  </div>
</template>

<script>
import { BgButton, BgText, BgIcon, BgMenu, BgMenuItem } from '@transfeeradev/bridge';
import { limitsTypeDescriptions } from '@/apps/admin/limits/constants/limitTypes';

export default {
  name: 'limits-card',
  components: {
    BgButton,
    BgText,
    BgIcon,
    BgMenu,
    BgMenuItem
  },
  props: {
    limit: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedText() {
      return limitsTypeDescriptions[this.limit.type] || this.limit.type;
    }
  }
};
</script>

<style scoped>
.limits-card {
  width: 250px;
  padding: var(--bg-spacing-sm);
  margin: var(--bg-spacing-sm) 0;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--bg-spacing-sm);
  border: 1px solid var(--bg-grey-light);
  border-radius: var(--bg-border-radius-md);
}
.limits-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.limits-card-header > *:last-child {
  margin-left: auto;
}
.limits-card-divider {
  width: 100%;
  height: 1px;
  margin: var(--bg-spacing-sm) 0;
  background: var(--bg-grey-light);
}
.limits-card-text {
  display: flex;
  align-items: center;
  gap: 4px;
}
.limits-card-icons {
  width: 12px;
  height: 12px;
}
.limits-card-menu-button {
  padding: 0;
}
</style>